module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.8de6a4ec.svg";